import { colors } from "lib/theme";
import { debounce } from "lodash";
import Router from "next/router";
import NProgress from "nprogress";
import { createGlobalStyle } from "styled-components";

NProgress.configure({ showSpinner: false });

const debouncedStart = debounce(NProgress.start, 500);

Router.events.on("routeChangeStart", (url) => {
  console.log(`Loading: ${url}`);
  debouncedStart();
});
Router.events.on("routeChangeComplete", () => {
  debouncedStart.cancel();
  NProgress.done();
});
Router.events.on("routeChangeError", () => {
  debouncedStart.cancel();
  NProgress.done();
});

const color = colors.pink[500];
const height = 3;

const GlobalStyles = createGlobalStyle`
  #nprogress {
    pointer-events: none;
    ${(p) => p.theme.isApp && `display: none;`}
  }
  #nprogress .bar {
    background: ${color};
    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;
    width: 100%;
    height: ${height}px;
  }
  #nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px ${color}, 0 0 5px ${color};
    opacity: 1;
    transform: rotate(3deg) translate(0px, -4px);
  }
  #nprogress .spinner {
    display: "block";
    position: fixed;
    z-index: 1031;
    top: 15px;
    right: 15px;
  }
  #nprogress .spinner-icon {
    width: 18px;
    height: 18px;
    box-sizing: border-box;
    border: solid 2px transparent;
    border-top-color: ${color};
    border-left-color: ${color};
    border-radius: 50%;
    animation: nprogress-spinner 400ms linear infinite;
  }
  .nprogress-custom-parent {
    overflow: hidden;
    position: relative;
  }
  .nprogress-custom-parent #nprogress .spinner,
  .nprogress-custom-parent #nprogress .bar {
    position: absolute;
  }
  @keyframes nprogress-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

GlobalStyles.defaultProps = { theme: {} };

export default GlobalStyles;
